module.exports = __webpack_public_path__ + "static/media/video.ff94b516.mp4";